var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowVulnerabilityPath)?_c('div',[(_vm.hasBlobPath)?_c('gl-link',{attrs:{"href":_vm.fileUrl}},[_c('gl-truncate',{attrs:{"text":_vm.locationString,"position":"middle"}})],1):_c('gl-truncate',{attrs:{"text":_vm.locationString,"position":"middle"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }